'use strict';

var designTokens_generated_designTokens = require('./designTokens-CKP-YoT2.js');

const getEnabledFeatureFlags = () => {
    if (globalThis.document === undefined) {
        return { global: [] };
    }
    const enabledFeatureFlagsBase64 = globalThis.document.querySelector('meta[name="enabledFeatureFlags"]')?.content;
    if (enabledFeatureFlagsBase64 == null) {
        return { global: [] };
    }
    const enabledFeatureFlagsJson = globalThis.atob(enabledFeatureFlagsBase64);
    return JSON.parse(enabledFeatureFlagsJson);
};
const GlobalFeatureFlags = {};
try {
    const enabledFeatureFlags = getEnabledFeatureFlags();
    if (enabledFeatureFlags.global != null) {
        for (const flag of enabledFeatureFlags.global) {
            GlobalFeatureFlags[flag] = true;
        }
    }
}
catch (error) {
    console.error('Could not read global feature flags', error);
}

const theme = new Proxy({ ...designTokens_generated_designTokens.defaultBrand }, {
    get: (_, prop) => {
        const themeOverride = {
            ...designTokens_generated_designTokens.defaultBrand,
            borderRadius: GlobalFeatureFlags.DesignSystemRoundedCorners
                ? designTokens_generated_designTokens.borderRadius
                : {
                    ...designTokens_generated_designTokens.borderRadius,
                    100: designTokens_generated_designTokens.borderRadius[50],
                    200: designTokens_generated_designTokens.borderRadius[50],
                },
        };
        return themeOverride[prop];
    },
    ownKeys(target) {
        return Reflect.ownKeys(target);
    },
});

exports.GlobalFeatureFlags = GlobalFeatureFlags;
exports.theme = theme;
//# sourceMappingURL=index-CIVOGJRG.js.map
